export const createTabIndexCalculator = ({ sectionTabIndexOffset = 0, columns = [] }) => {
  const inputsPerRow = columns.reduce((sum, col) => {
    return sum + (col.visible ? col.inputCount : 0);
  }, 0);

  const columnPositions = {};
  let currentPosition = 0;
  columns.forEach(col => {
    columnPositions[col.name] = {
      startPosition: currentPosition,
      visible: col.visible,
      inputCount: col.inputCount,
      isInputDisabled: col.isInputDisabled
    };
    if (col.visible) {
      currentPosition += col.inputCount;
    }
  });

  return (rowIndex, columnName, inputIndexInColumn = 0, isDisabled = false) => {
    if (isDisabled) return -1;

    const colInfo = columnPositions[columnName];
    if (!colInfo || !colInfo.visible) return -1;

    if (colInfo.isInputDisabled && colInfo.isInputDisabled(inputIndexInColumn)) {
      return -1;
    }

    const positionInRow = colInfo.startPosition + inputIndexInColumn;
    // +1 because tabIndex 0 has special meaning (follows DOM order)
    return sectionTabIndexOffset + (rowIndex * inputsPerRow) + positionInRow + 1;
  };
};

export const createTicketsSectionColumns = ({ showOffer, showForecast, showActuals }) => [
  { name: 'item', visible: true, inputCount: 1 },
  { name: 'available', visible: showOffer, inputCount: 1 },
  { name: 'comps', visible: showOffer, inputCount: 1 },
  { name: 'kills', visible: showOffer, inputCount: 1 },
  { name: 'salePrice', visible: showOffer, inputCount: 1 },
  { name: 'forecastQty', visible: showForecast, inputCount: 1 },
  { name: 'forecastPrice', visible: showForecast, inputCount: 1 },
  { name: 'actualsQty', visible: showActuals, inputCount: 1 },
  { name: 'actualsPrice', visible: showActuals, inputCount: 1 }
];

export const createBudgetLineItemColumns = ({
  hasOfferColumn,
  showOffer,
  showForecast,
  showActuals
}) => [
  { name: 'item', visible: true, inputCount: 1 },
  { name: 'offerQty', visible: hasOfferColumn && showOffer, inputCount: 1 },
  { name: 'offerAmount', visible: hasOfferColumn && showOffer, inputCount: 1 },
  { name: 'forecastQty', visible: showForecast, inputCount: 1 },
  { name: 'forecastAmount', visible: showForecast, inputCount: 1 },
  { name: 'actualsQty', visible: showActuals, inputCount: 1 },
  { name: 'actualsAmount', visible: showActuals, inputCount: 1 }
];
